import React from 'react';
import cn from 'classnames';
import { useTheme, useMergeClasses } from '../../../../../theme';
import { CircularProgress } from '@mui/material';
const Switch = ({ classes, checked, onChange, required, disabled, inverted, loading, label, labelPosition = 'left', dataTestId }) => {
    const { Switch: defaultClasses } = useTheme('Shared');
    const css = useMergeClasses(defaultClasses, classes);
    const handleClick = (e) => {
        if (!disabled && !loading && onChange) {
            onChange(e);
        }
    };
    const handleKeyDown = (e) => {
        if (!disabled && !loading && (e.key === 'Enter' || e.key === ' ') && onChange) {
            e.preventDefault();
            onChange(e);
        }
    };
    return (React.createElement("div", { className: cn(css.root, {
            [css.checked]: checked,
            [css.disabled]: disabled,
            [css.required]: required,
            [css.inverted]: inverted,
            [css.loading]: loading,
            [css.labelPosition__left]: labelPosition === 'left',
            [css.labelPosition__right]: labelPosition === 'right'
        }), onClick: handleClick, onKeyDown: handleKeyDown, role: "switch", "aria-checked": checked, "aria-disabled": disabled, tabIndex: disabled ? -1 : 0, "data-test-id": dataTestId },
        label && React.createElement("div", { className: css.label }, label),
        React.createElement("div", { className: css.toggle },
            React.createElement("span", { className: css.handle },
                React.createElement("span", { className: css.handle__circular }),
                React.createElement(CircularProgress, { className: css.handle__circular_progress, size: 14, thickness: 6 })))));
};
export default Switch;
